import {
  useAppDispatch,
  useAppSelector,
  productNotificationModalState,
  setShouldShowNotificationModal,
  setLastTimeNotificationModalWasShown,
} from 'src/store';
import { useCallback, useMemo } from 'react';
import { batch } from 'react-redux';
import dayjs from 'dayjs';

export const useNotificationModal = () => {
  const { shouldShowNotificationModal, lastTimeNotificationModalWasShown } =
    useAppSelector(productNotificationModalState);
  const dispatch = useAppDispatch();

  const changeShouldShowNotificationModal = useCallback(
    (value: boolean) => {
      dispatch(setShouldShowNotificationModal(value));
    },
    [dispatch],
  );

  // TODO: we don't use it in the MVP
  const changeLastTimeNotificationModalWasShown = useCallback(
    (value: Date | null) => {
      dispatch(setLastTimeNotificationModalWasShown(value));
    },
    [dispatch],
  );

  const changeNotificationModalState = useCallback(
    ({
      shouldShow,
      lastTimeWasShown,
    }: {
      shouldShow: boolean;
      lastTimeWasShown: Date | null;
    }) => {
      batch(() => {
        dispatch(setLastTimeNotificationModalWasShown(lastTimeWasShown));
        dispatch(setShouldShowNotificationModal(shouldShow));
      });
    },
    [dispatch],
  );

  // TODO: we don't use it in the MVP
  const isTimeToShowNotificationModal =
    (lastTimeNotificationModalWasShown === null ||
      dayjs().diff(dayjs(lastTimeNotificationModalWasShown), 'hour') >= 24) &&
    !shouldShowNotificationModal;

  return useMemo(
    () => ({
      isTimeToShowNotificationModal,
      shouldShowNotificationModal,
      changeShouldShowNotificationModal,
      changeLastTimeNotificationModalWasShown,
      changeNotificationModalState,
    }),
    [
      isTimeToShowNotificationModal,
      shouldShowNotificationModal,
      changeShouldShowNotificationModal,
      changeLastTimeNotificationModalWasShown,
      changeNotificationModalState,
    ],
  );
};
